import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ─── CRITICAL: Inject inline CSS for instant first paint ───
function injectCriticalCSS() {
  const style = document.createElement('style');
  style.setAttribute('data-critical', 'true');
  style.textContent = [':root{--bg-darker:#F5EFE6;--bg-dark:#FAF7F2;--bg-card:#FFF;--accent-orange:#A8BBA3;--accent-orange-hover:#6F8C6B;--accent-orange-light:#D8A7B1;--text-light:#4A4A4A;--text-gray:#6F8C6B}', 'body{font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;background-color:#F5EFE6;color:#4A4A4A;line-height:1.6;overflow-x:hidden;margin:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}', 'h1,h2,h3,h4,h5,h6{font-family:Montserrat,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-weight:800;line-height:1.2}', '@font-face{font-family:"Montserrat";font-style:normal;font-weight:900;font-display:swap;src:url(https://fonts.gstatic.com/s/montserrat/v29/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w5aXp-p7K4KLg.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}', '@font-face{font-family:"Montserrat";font-style:normal;font-weight:700;font-display:swap;src:url(https://fonts.gstatic.com/s/montserrat/v29/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w5aXp-p7K4KLg.woff2) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}', 'img{max-width:100%;height:auto}', '.gradient-overlay{background:linear-gradient(180deg,rgba(168,187,163,.15) 0%,transparent 100%)}'].join('');
  document.head.insertBefore(style, document.head.firstChild);
}
// ─── Resource hints + preloads ───
function injectResourceHints() {
  const head = document.head;
  [{
    href: 'https://fonts.gstatic.com',
    co: 'anonymous'
  }, {
    href: 'https://cdn.shopify.com',
    co: 'anonymous'
  }].forEach(({
    href,
    co
  }) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    link.crossOrigin = co;
    head.appendChild(link);
  });
  // Preload Montserrat woff2 directly
  const fontPreload = document.createElement('link');
  fontPreload.rel = 'preload';
  fontPreload.as = 'font';
  fontPreload.type = 'font/woff2';
  fontPreload.crossOrigin = 'anonymous';
  fontPreload.href = 'https://fonts.gstatic.com/s/montserrat/v29/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w5aXp-p7K4KLg.woff2';
  head.appendChild(fontPreload);
  // Preload hero image — TWO preloads for the two most common sizes
  // Mobile (most traffic): 400w
  const heroMobile = document.createElement('link');
  heroMobile.rel = 'preload';
  heroMobile.as = 'image';
  heroMobile.href = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_21_1.webp?v=1771098855&width=400';
  heroMobile.setAttribute('fetchpriority', 'high');
  heroMobile.media = '(max-width: 640px)';
  head.appendChild(heroMobile);
  // Desktop: 700w
  const heroDesktop = document.createElement('link');
  heroDesktop.rel = 'preload';
  heroDesktop.as = 'image';
  heroDesktop.href = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_21_1.webp?v=1771098855&width=700';
  heroDesktop.setAttribute('fetchpriority', 'high');
  heroDesktop.media = '(min-width: 641px)';
  head.appendChild(heroDesktop);
  // Google Fonts — non-blocking, deferred
  const fontUrl = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Inter:wght@400;500;600;700&display=swap';
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = fontUrl;
  fontLink.media = 'print';
  fontLink.onload = function () {
    fontLink.media = 'all';
  };
  head.appendChild(fontLink);
  const noscript = document.createElement('noscript');
  const fallbackLink = document.createElement('link');
  fallbackLink.rel = 'stylesheet';
  fallbackLink.href = fontUrl;
  noscript.appendChild(fallbackLink);
  head.appendChild(noscript);
}
// Execute BEFORE render
injectCriticalCSS();
injectResourceHints();
render(<App data-id="element-309" />, document.getElementById('root'));
// Defer non-critical scripts
if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      import('./utils/globalPriceReplacer').then(({
        initGlobalPriceReplacer
      }) => initGlobalPriceReplacer());
    }, {
      timeout: 3000
    });
  } else {
    setTimeout(() => {
      import('./utils/globalPriceReplacer').then(({
        initGlobalPriceReplacer
      }) => initGlobalPriceReplacer());
    }, 500);
  }
}